import type { PaletteColor } from "../catalog/colors";
import { api } from "./client";

/**
 * The shop's colour palette.
 *
 * Reading it and adding to it. The palette is server state like everything else
 * here — a colour added by one administrator is there for the next one, which
 * is exactly what browser storage could not give us.
 */
export const colorsApi = {
  list: (signal?: AbortSignal) =>
    api
      .get<{ colors: PaletteColor[] }>("/admin/colors", undefined, signal)
      .then((response) => response.colors),

  add: (body: { name: string; swatch_hex: string }) =>
    api
      .post<{ color: PaletteColor }>("/admin/colors", body)
      .then((response) => response.color),
};
